import { type useReadOnlyEntityAttachments } from '@Hooks/Attachments/useReadOnlyEntityAttachments';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { Button, defaultIconSize, useModalState } from '@synqo/frontend-component-library';
import { IconPaperclip } from '@tabler/icons-react';
import { type FC } from 'react';
import { AttachmentsModal } from './AttachmentsModal';

export interface ReadOnlyEntityAttachmentsButtonProps {
    attachmentsInfo: ReturnType<typeof useReadOnlyEntityAttachments>;
}

/** Header button opening a read-only (list + download) attachments modal. */
// @ai-generated 2026-07-13T00:00:00Z by philipp.kammerer@synqony.com using claude-opus-4-8
export const ReadOnlyEntityAttachmentsButton: FC<ReadOnlyEntityAttachmentsButtonProps> = ({ attachmentsInfo }) => {
    const { isOpen, open, close } = useModalState();
    const { attachments, download, invalidateList } = attachmentsInfo;

    useRemoteCacheInvalidation('attachments', invalidateList);

    return (
        <>
            <Button key="attachments" onClick={open} appearance="transparent" label="Anhänge" tooltip="Anhänge">
                <IconPaperclip size={defaultIconSize} />
            </Button>
            <AttachmentsModal
                mode="readonly"
                isOpen={isOpen}
                onClose={close}
                attachments={attachments}
                canDownload
                onDownload={download}
            />
        </>
    );
};
